import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import AlpacaChatbot from "../components/AlpacaChatbot";
import { whoami, getEntityTags } from "../services/APIClient";

function Chatbot() {
  const [teacherid, setTeacherid] = useState(null);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [isAuthorised, setIsAuthorised] = useState(false);

  useEffect(() => {
    whoami()
      .then((response) => {
        const user = response?.data || response;
        if (user?.stakeholder) {
          const id = user.stakeholder.id;
          setTeacherid(id);
          setName(user.stakeholder.name);
          return getEntityTags("teacher", id);
        }
      })
      .then((tags) => {
        if (tags) {
          console.log("[Chatbot] getEntityTags response:", tags);
          const tag = tags.find(
            (t) => t.tag_definition?.tag_name === "chatbot_teacher_access"
          );
          console.log("[Chatbot] chatbot_teacher_access tag:", tag);
          setIsAuthorised(tag?.tag_value === "ON");
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <Container fluid>
      <HeadingBanner
        name={name ? `Welcome ${name}!` : "ALPACA AI Assistant"}
        isLoggedIn={true}
        cloud={true}
        teacherid={teacherid}
      />
      <Row className="vh-100">
        <LeftPanel />
        <Col sm={{ span: 10, offset: 2 }} className="blue-background" style={{ paddingTop: "5%" }}>
          {!loading && (
            isAuthorised
              ? <AlpacaChatbot />
              : (
                <div style={{ textAlign: "center", marginTop: "10%", color: "#666" }}>
                  <h3>Access Restricted</h3>
                  <p>You do not have permission to access this feature.</p>
                </div>
              )
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default Chatbot;
